import * as R from "ramda";

export const limitSpeed = (speed: number, speedLimit: number | null): number => {
    if (R.isNil(speedLimit)) {
        return speed;
    }

    return R.min(speed, speedLimit);
}